import { router } from '@inertiajs/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faGauge, faFileLines, faUsers,
  faXmark, faRightFromBracket, faCrown, faFilePdf,
  faClockRotateLeft, faBell, faGear
} from '@fortawesome/free-solid-svg-icons'
import logo from '../../../assets/images/logo-nav-foo-bar.png'

const NAV_ITEMS = [
  { icon: faGauge,      label: 'Dashboard',           href: '/superadmin/dashboard' },
  { icon: faFileLines,  label: 'Semua Laporan',        href: '/superadmin/reports',   matchPath: '/superadmin/reports' },
  { icon: faUsers,      label: 'Pengguna dan Admin',   href: '/superadmin/users',     matchPath: '/superadmin/users' },
  { icon: faFilePdf,    label: 'Dokumen PDF',          href: '/superadmin/documents', matchPath: '/superadmin/documents' },
  { icon: faClockRotateLeft, label: 'Audit Log',       href: '/superadmin/audit_logs', matchPath: '/superadmin/audit_logs' },
  { icon: faBell,       label: 'Notifikasi',           href: '/superadmin/notifications', matchPath: '/superadmin/notifications' },
  { icon: faGear,       label: 'Pengaturan',           href: '/superadmin/settings', matchPath: '/superadmin/settings' },
]

export default function SuperadminSidebar({ current_user, open, onClose }) {
  const logout = () => { if (confirm('Yakin ingin keluar?')) router.delete('/logout') }

  const isActive = (item) => {
    const path = window.location.pathname
    const compareTo = item.matchPath ?? item.href.split('?')[0]
    return compareTo !== '#' && (path === compareTo || path.startsWith(compareTo + '/'))
  }

  return (
    <>
      {open && <div className="fixed inset-0 z-20 bg-black/60 lg:hidden" onClick={onClose} />}
      <aside className={`fixed lg:static inset-y-0 left-0 z-30 w-64 bg-gray-900 border-r border-gray-800 flex flex-col transition-transform duration-200 ${open ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}>
        <div className="flex items-center gap-3 px-5 h-16 border-b border-gray-800">
          <img src={logo} className="h-8 w-auto" alt="WBS" />
          <div>
            <div className="text-sm font-bold text-white leading-none">WBS Kalsel</div>
            <div className="text-[10px] text-indigo-400 mt-0.5 flex items-center gap-1">
              <FontAwesomeIcon icon={faCrown} className="w-2.5 h-2.5" /> Superadmin
            </div>
          </div>
          <button className="ml-auto lg:hidden text-gray-500" onClick={onClose}>
            <FontAwesomeIcon icon={faXmark} className="w-4 h-4" />
          </button>
        </div>

        <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-0.5">
          <p className="text-[10px] font-semibold text-gray-600 uppercase tracking-widest px-3 mb-2">Menu Utama</p>
          {NAV_ITEMS.map(item => (
            <a key={item.label} href={item.href}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive(item) ? 'bg-indigo-600/20 text-indigo-400 ring-1 ring-indigo-600/30' : 'text-gray-400 hover:bg-gray-800 hover:text-gray-100'}`}>
              <FontAwesomeIcon icon={item.icon} className="w-4 h-4 flex-shrink-0" />
              <span className="flex-1">{item.label}</span>
            </a>
          ))}
        </nav>

        <div className="border-t border-gray-800 p-4">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-indigo-900/60 ring-1 ring-indigo-600/40 flex items-center justify-center flex-shrink-0">
              <FontAwesomeIcon icon={faCrown} className="w-3.5 h-3.5 text-indigo-400" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-gray-200 truncate">{current_user?.name || 'Superadmin'}</div>
              <div className="text-[11px] text-gray-500 truncate">{current_user?.email}</div>
            </div>
            <button onClick={logout} className="text-gray-600 hover:text-red-400 transition-colors" title="Keluar">
              <FontAwesomeIcon icon={faRightFromBracket} className="w-4 h-4" />
            </button>
          </div>
        </div>
      </aside>
    </>
  )
}
